<div #ticket style="padding:10px">
  <div id="printThis">
    <div class="basket-bottom"></div>
    <div id="loadingPage" *ngIf="loading"></div>
    <div *ngIf="ticketContent && !loading" [innerHtml]="ticketContent | safeHtml"></div>
    <hr *ngIf="ticketContent && !loading">
  </div>
  <div *ngIf="ticketContent && !loading" class="text-center">
    <button class="btn btn-primary" (click)="bsModalRef.hide()">Fermer</button>
  </div>
</div>